import { Alert, AlertTitle } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface ProductTestLinkPoAlertProps {
  onProceed: () => void
}

export const ProductTestLinkPoAlert: FC<ProductTestLinkPoAlertProps> = ({ onProceed }) => (
  <Alert
    icon={<WarningOutlined className='text-[#EF6C00]' />}
    severity='warning'
    variant='filled'
    color='warning'
    className='bg-[#FFF4E5] text-[#663C00]'
    action={
      <Button
        appearance='outlined'
        onClick={onProceed}
        size='small'
        className='self-center border-[#EF6C00]/50 text-[#EF6C00] hover:border-[#FF9800] hover:bg-[#FFF3E0] hover:text-[#FF9800]'
      >
        Proceed
      </Button>
    }
  >
    <AlertTitle>This lot and batch already exist. </AlertTitle>
    Would you like to link these Test Results to this Purchase Order?
  </Alert>
)
